<template>
  <ModalFilterTransaction
    v-if="modalShowFilterTransaction"
    :filter="filter"
    @closeModal="closeModal"
    @submitFilter="submitFilter"
  />
  <ModalExportReportDaily
    v-if="modalShowExportReportDaily"
    @close="closeModalExportReportDaily"
    @submit="submitExport"
  />
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Laporan Transaksi" />
      <div
        class="border-t-2 border-primary bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100"
      >
        <div
          v-if="!isConnected"
          class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4"
          role="alert"
        >
          <p class="font-bold">Connection Status</p>
          <p>Attempting to connect to real-time updates...</p>
        </div>
        <div id="table-header" class="mb-5 flex justify-between items-end">
          <div class="mb-5 flex justify-between">
            <AddButton
              to_url="#"
              button_text="Filter"
              button_class="text-base py-2 font-medium"
              @click="showModal"
            />
            <AddButton
              to_url="#"
              button_text="Download Excel"
              button_class="text-base py-2 mx-3 font-medium"
              @click="exportExcel"
            />
            <AddButton
              to_url="#"
              button_text="Export Laporan"
              button_class="text-base py-2 mx-3 font-medium"
              @click="showModalExportLaporan"
            />
          </div>
        </div>
        <div v-if="isLoading" class="flex justify-center items-center py-4">
          <div
            class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"
          ></div>
        </div>
        <div v-else class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>Tanggal</TableHeadCell>
                    <TableHeadCell>Jumlah Transaksi</TableHeadCell>
                    <TableHeadCell>Produk Terjual</TableHeadCell>
                    <TableHeadCell>Qty Order</TableHeadCell>
                    <TableHeadCell>Qty Cancel</TableHeadCell>
                    <TableHeadCell>Qty Terjual</TableHeadCell>
                    <TableHeadCell>Grand Total</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allSalesOrders.length == 0">
                    <TableCell
                      colspan="6"
                      customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor
                    >
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <template
                    v-else
                    v-for="dateGroup in allSalesOrders"
                    :key="dateGroup.date"
                  >
                    <!-- Main Row for Each Date -->
                    <TableRow>
                      <TableCell>{{ dateGroup.date }}</TableCell>
                      <TableCell>{{ dateGroup.sales_order_count }}</TableCell>
                      <TableCell>{{
                        dateGroup.unique_items_sold.length
                      }}</TableCell>
                      <TableCell>{{
                        dateGroup.total_products_ordered
                      }}</TableCell>
                      <TableCell>{{
                        dateGroup.total_products_canceled
                      }}</TableCell>
                      <TableCell>{{ dateGroup.total_products_sold }}</TableCell>
                      <TableCell>{{
                        formatRupiah(dateGroup.grand_total)
                      }}</TableCell>
                    </TableRow>

                    <!-- Nested Rows for Unique Items Sold -->
                    <TableRow
                      v-for="item in dateGroup.unique_items_sold"
                      :key="`${dateGroup.date}-${item.item_id}`"
                    >
                      <TableCell></TableCell>
                      <TableCell colspan="2"
                        >↳ {{ item.item.code }} -
                        {{ item.item.name }}</TableCell
                      >
                      <TableCell>{{ item.ordered.total_qty }}</TableCell>
                      <TableCell>{{ item.canceled.total_qty }}</TableCell>
                      <TableCell>{{ item.sold.total_qty }}</TableCell>
                      <!-- <td class="py-3 px-3 border-b text-left">{{ item.total_qty }}</td> -->
                      <TableCell>{{ formatRupiah((item?.sold?.subtotal || 0) - (item?.sold?.discount || 0)) }}</TableCell>
                    </TableRow>
                  </template>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import IndexView from "@/views/IndexView.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
import { io } from "socket.io-client";
import { mapGetters } from "vuex";
import { formatRupiah } from "@/helpers/formatRupiah";
import * as XLSX from "xlsx";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableHeadCell,
} from "@/components/table";
import ModalExportReportDaily from "@/components/modals/ModalExportReportDaily.vue";

export default {
  name: "TransactionView",
  components: {
    PageTitle,
    IndexView,
    AddButton,
    ModalFilterTransaction,
    ViewContainer,
    TableComponent,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeadCell,
    ModalExportReportDaily,
  },
  data() {
    return {
      modalShowFilterTransaction: false,
      modalShowExportReportDaily: false,
      isBlur: false,
      listTransaction: [],
      socket: null,
      message: "",
      messages: [],
      isConnected: false,
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      filter: {},
    };
  },
  async created() {
    this.connectWebSocket();
    this.fetchSalesOrders();
    this.fetchAdditionalData();
  },
  computed: {
    ...mapGetters("reports", ["allSalesOrders"]),
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("marketings", ["allMarketings"]),
    ...mapGetters("payment_methods", ["allPaymentMethods"]),
  },
  beforeUnmount() {
    try {
      if (this.socket) {
        // Remove all listeners to prevent memory leaks
        this.socket.removeAllListeners();
        this.socket.disconnect();
        this.socket = null;
      }
      this.isConnected = false;
      this.listTransaction = [];
      this.messages = [];
    } catch (error) {
      console.error("Error during cleanup:", error);
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchSalesOrders({ page: newVal });
      },
    },
  },
  methods: {
    formatRupiah,
    async fetchSalesOrders(params = {}) {
      await this.$store.dispatch("reports/fetchDailySalesOrders", params);
    },
    async fetchAdditionalData() {
      this.$store.dispatch("tables/fetchTables", { limit: 1000 });
      this.$store.dispatch("marketings/fetchMarketings", { limit: 1000 });
      this.$store.dispatch("payment_methods/fetchPaymentMethods", {
        limit: 1000,
      });
    },
    connectWebSocket() {
      try {
        this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
          reconnection: true, // Enable auto-reconnection
          reconnectionAttempts: 5, // Maximum number of reconnection attempts
          timeout: 10000, // Connection timeout in milliseconds
        });

        this.socket.on("connect_error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.socket.on("disconnect", (reason) => {
          this.messages.push(reason);
          this.isConnected = false;
        });

        // Menerima pesan dari server
        this.socket.on("serverMessage", (data) => {
          this.handleWebSocketMessage(data);
          this.messages.push(data.message);
        });

        this.socket.on("welcome", (data) => {
          this.messages.push(data.message);
        });

        this.socket.on("new_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("update_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("delete_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("connect", () => {
          this.isConnected = true;
        });

        this.socket.on("error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.handleReconnect();
      } catch (error) {
        this.isConnected = false;
      }
    },
    sendMessage() {
      // Kirim pesan ke server
      this.socket.emit("clientMessage", this.message);
      this.message = ""; // Reset input
    },
    handleWebSocketMessage(data) {
      this.isLoading = true;
      try {
        let index;

        // Validasi data terlebih dahulu
        if (!data || !data.type) {
          return;
        }

        switch (data.type) {
          case "INITIAL_DATA":
            if (Array.isArray(data.transactions)) {
              this.listTransaction = data.transactions;
              this.fetchSalesOrders();
            } else {
              console.warn("Invalid transactions data format:", data);
            }
            break;
          case "NEW_ITEMS":
            if (data.items && data.route == "sales-order") {
              this.listTransaction.unshift(data.items);
              this.fetchSalesOrders();
            }
            break;
          case "UPDATE_ITEMS":
            if (data.items && data.items.id && data.route == "sales-order") {
              index = this.listTransaction.findIndex(
                (t) => t.id === data.items.id
              );
              if (index !== -1) {
                this.listTransaction.splice(index, 1, data.items);
              }
              this.fetchSalesOrders();
            }
            break;
          case "DELETE_ITEMS":
            if (data.id && data.route == "sales-order") {
              this.listTransaction = this.listTransaction.filter(
                (transaction) => String(transaction.id) !== String(data.id)
              );
              this.fetchSalesOrders();
            }
            break;
          default:
            console.warn("Unknown message type:", data.type);
        }
      } catch (error) {
        console.error("Error handling websocket message:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleReconnect() {
      if (this.socket) {
        this.socket.on("reconnect_attempt", (attemptNumber) => {
          console.log(`Reconnection attempt ${attemptNumber}`);
        });

        this.socket.on("reconnect", () => {
          console.log("Reconnected successfully");
          this.isConnected = true;
          // Mungkin perlu memuat ulang data
          this.socket.emit("requestInitialData");
        });

        this.socket.on("reconnect_failed", () => {
          console.log("Failed to reconnect");
          this.isConnected = false;
        });
      }
    },
    showModal() {
      this.modalShowFilterTransaction = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterTransaction = false;
        this.isBlur = false;
      }, 200);
    },
    submitFilter(filter) {
      let params = {};
      if (filter.capacity) {
        params.capacity = filter.capacity;
      }

      if (filter.type) {
        params.order_type = filter.type;
      }

      if (filter.status) {
        params.status = filter.status;
      }

      if (filter.marketing_id) {
        params.marketing_id = filter.marketing_id;
      }

      if (filter.global_discount_id) {
        params.global_discount_id = filter.global_discount_id;
      }

      if (filter.item_category_id) {
        params.item_category_id = filter.item_category_id;
      }

      if (filter.payment_method_id) {
        params.payment_method_id = filter.payment_method_id;
      }

      if (filter.table_id) {
        params.table_id = filter.table_id;
      }

      if (filter.cash_register_id) {
        params.cash_register_id = filter.cash_register_id;
      }

      if (filter.rangeDate) {
        params.start_date = filter.rangeDate[0];
        params.end_date = filter.rangeDate[1];
      }

      this.fetchSalesOrders(params);

      // this.allSalesOrders.filter((so) => {
      //   return (
      //     (!filter.rangeDate && (filter.rangeDate && so.created_at >= filter.rangeDate[0] && so.created_at <= filter.rangeDate[1]))
      //   );
      // });

      this.updateFilter(filter);
    },
    updateFilter(filter) {
      this.filter = filter;
    },
    async exportExcel() {
      const workbook = XLSX.utils.book_new();
      const worksheetData = [];

      // Add header row
      worksheetData.push([
        "Tanggal",
        "Jumlah Transaksi",
        "Produk Terjual",
        "Qty Order",
        "Qty Cancel",
        "Qty Terjual",
        "Grand Total",
      ]);

      // Populate data rows
      this.allSalesOrders.forEach((dateGroup) => {
        worksheetData.push([
          dateGroup.date,
          dateGroup.sales_order_count,
          dateGroup.unique_items_sold.length,
          dateGroup.total_products_ordered,
          dateGroup.total_products_canceled,
          dateGroup.total_products_sold,
          dateGroup.grand_total,
        ]);

        dateGroup.unique_items_sold.forEach((item) => {
          worksheetData.push([
            "",
            "",
            `${item.item.code} - ${item.item.name}`,
            item.ordered.total_qty,
            item.canceled.total_qty,
            item.sold.total_qty,
            Number(item.sold.subtotal || 0) - Number(item.sold.discount || 0),
          ]);
        });
      });

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Sales");

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, "Daily_Sales_Report.xlsx");
    },    
    formatDateRange(start, end) {
      if (!start || !end) {
        return 'Periode: -';
      }
      const startDate = new Date(start).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
      const endDate = new Date(end).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
      return `Periode: ${startDate} s/d ${endDate}`;
    },
    showModalExportLaporan() {
      this.modalShowExportReportDaily = true;
    },
    closeModalExportReportDaily() {
      this.modalShowExportReportDaily = false;
    },
    async submitExport(exportParams) {
      try {
        // Close the modal
        this.modalShowExportReportDaily = false;
        
        // Show loading state
        this.$toast.add({
          severity: 'info',
          summary: 'Mempersiapkan Laporan',
          detail: 'Sedang memproses data untuk diekspor...',
          life: 3000
        });

        // If we need to filter data based on date range
        let dataToExport = [...this.allSalesOrders];
        let periodeStart = '';
        let periodeEnd = '';
        
        // Filter by date range if provided
        if (exportParams.startDate && exportParams.endDate) {
          const startDate = new Date(exportParams.startDate);
          const endDate = new Date(exportParams.endDate);
          endDate.setHours(23, 59, 59, 999); // Include the entire end day
          await this.fetchSalesOrders({
              start_date: startDate.toISOString(),
              end_date: endDate.toISOString(),
            });

          dataToExport = this.allSalesOrders.filter(group => {
            const groupDate = new Date(group.date);
            return groupDate >= startDate && groupDate <= endDate;
          });

          periodeStart = new Date(exportParams.startDate);
          periodeEnd = new Date(exportParams.endDate);
        }

        // Prepare data for export
        const exportData = {
          title: 'LAPORAN PENJUALAN HARIAN',
          dateRange: this.formatDateRange(periodeStart, periodeEnd),
          exportDate: new Date().toLocaleString('id-ID', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }),
          data: dataToExport,
          includeDetails: exportParams.includeDetails,
          includeSummary: exportParams.includeSummary
        };
        console.log(exportData);

        // Call the export function
        this.exportToExcel(exportData);

      } catch (error) {
        console.error('Export error:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Ekspor Gagal',
          detail: 'Terjadi kesalahan saat mengekspor laporan',
          life: 3000
        });
      }
    },
    async exportToExcel(exportData) {
      try {
        const workbook = XLSX.utils.book_new();
        const worksheetData = [];
        const merges = [];
        const styles = {};
        
        // Define formats
        const numberFormat = '#,##0';
        const currencyFormat = '#,##0.00';
        
        // Add title and headers
        worksheetData.push([exportData.title, '', '', '', '']);
        worksheetData.push([exportData.dateRange, '', '', '', '']);
        worksheetData.push([`Dicetak pada: ${exportData.exportDate}`, '', '', '', '']);
        worksheetData.push(["", "", "", "", ""]); // Empty row

        // Add data rows
        exportData.data.forEach((dateGroup, groupIndex) => {
          const startRow = worksheetData.length;
          let itemCount = 0;

          // Add date header with formatted date
          const formattedDate = new Date(dateGroup.date).toLocaleDateString('id-ID', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
          });
          const dateHeader = `Tanggal: ${formattedDate}`;
          worksheetData.push([dateHeader, "", "", "", ""]);
          itemCount++;

          // Add column headers
          worksheetData.push(["", "Kode - Nama Produk", "Qty", "Harga Satuan", "Subtotal", "Total Diskon", "Grand Total"]);
          itemCount++;

          // Add product details if includeDetails is true
          if (exportData.includeDetails) {
            dateGroup.unique_items_sold.forEach((item) => {
              worksheetData.push([
                "",
                `${item.item.code} - ${item.item.name}`,
                item.sold.total_qty,
                Number(item.item.sale_price).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }),
                Number(item.sold.subtotal).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }),
                Number(item.sold.discount).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }),
                Number((item?.sold?.subtotal || 0) - (item?.sold?.discount || 0)).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }),
              ]);
              itemCount++;
            });
          }

          // Add summary rows if includeSummary is true
          if (exportData.includeSummary) {
            // Add summary row with total products and grand total
            worksheetData.push([
              "",
              "Jumlah",
              dateGroup.total_products_sold,
              "",
              Number(dateGroup.grand_total).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' }),
            ]);
            
            // Add transaction and product count summary
            worksheetData.push([
              "",
              `Jumlah Transaksi: ${dateGroup.sales_order_count}`,
              `Produk Terjual: ${dateGroup.unique_items_sold.length}`,
              "",
              "",
            ]);
            itemCount += 2;
          }

          // Add empty row after each date group (except the last one)
          if (groupIndex < exportData.data.length - 1) {
            worksheetData.push(["", "", "", "", ""]);
            itemCount++;
          }

          // Add styling (same as your existing styling)
          if (groupIndex === 0) {
            merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } });
            merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: 4 } });
            merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: 4 } });
            
            styles['A1'] = { 
              font: { bold: true, size: 16, color: { rgb: '2c3e50' } }, 
              alignment: { horizontal: 'center', vertical: 'center' } 
            };
            styles['A2'] = { 
              font: { bold: true, size: 12, color: { rgb: '34495e' } }, 
              alignment: { horizontal: 'center' } 
            };
            styles['A3'] = { 
              font: { italic: true, size: 11, color: { rgb: '7f8c8d' } }, 
              alignment: { horizontal: 'left' } 
            };
          }

          // Merge and style date header
          const dateRow = startRow;
          merges.push({ s: { r: dateRow, c: 0 }, e: { r: dateRow, c: 4 } });
          
          const dateCellRef = XLSX.utils.encode_cell({ r: dateRow, c: 0 });
          styles[dateCellRef] = { 
            font: { bold: true, size: 12, color: { rgb: '2c3e50' } },
            fill: { fgColor: { rgb: 'ecf0f1' } },
            border: {
              top: { style: 'thin', color: { rgb: 'bdc3c7' } },
              bottom: { style: 'thin', color: { rgb: 'bdc3c7' } }
            },
            alignment: { 
              horizontal: 'left',
              vertical: 'center',
              indent: 1
            }
          };

          // Style column headers
          const headerRow = startRow + 1;
          for (let c = 0; c < 5; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: headerRow, c });
            styles[cellRef] = { 
              font: { 
                bold: true, 
                color: { rgb: '2c3e50' },
                size: 11
              },
              fill: { fgColor: { rgb: 'f8f9fa' } },
              border: { 
                top: { style: 'thin', color: { rgb: 'dee2e6' } }, 
                bottom: { style: 'thin', color: { rgb: 'dee2e6' } },
                left: c === 0 ? { style: 'thin', color: { rgb: 'dee2e6' } } : {},
                right: { style: 'thin', color: { rgb: 'dee2e6' } }
              },
              alignment: { 
                horizontal: c >= 2 ? 'right' : 'left',
                vertical: 'center',
                wrapText: true
              }
            };
          }

          // Style data rows
          const firstDataRow = headerRow + 1;
          const lastDataRow = startRow + itemCount - (exportData.includeSummary ? 3 : 1);
          
          for (let r = firstDataRow; r <= lastDataRow; r++) {
            const rowStyle = {
              font: { size: 11, color: { rgb: '2c3e50' } },
              border: {
                left: { style: 'thin', color: { rgb: 'f1f3f5' } },
                right: { style: 'thin', color: { rgb: 'f1f3f5' } },
                bottom: { style: 'thin', color: { rgb: 'f1f3f5' } }
              },
              alignment: { vertical: 'center' }
            };
            
            // Style product name
            const productCell = XLSX.utils.encode_cell({ r, c: 1 });
            styles[productCell] = { ...rowStyle, alignment: { horizontal: 'left' } };
            
            // Style quantity
            const qtyCell = XLSX.utils.encode_cell({ r, c: 2 });
            styles[qtyCell] = { 
              ...rowStyle, 
              numFmt: numberFormat, 
              alignment: { horizontal: 'right' } 
            };
            
            // Style price
            const priceCell = XLSX.utils.encode_cell({ r, c: 3 });
            styles[priceCell] = { 
              ...rowStyle, 
              numFmt: currencyFormat, 
              alignment: { horizontal: 'right' } 
            };
            
            // Style subtotal
            const subtotalCell = XLSX.utils.encode_cell({ r, c: 4 });
            styles[subtotalCell] = { 
              ...rowStyle, 
              numFmt: currencyFormat, 
              alignment: { horizontal: 'right' } 
            };
            
            // Add alternating row color
            if (r % 2 === 0) {
              styles[productCell].fill = { fgColor: { rgb: 'f8f9fa' } };
              styles[qtyCell].fill = { fgColor: { rgb: 'f8f9fa' } };
              styles[priceCell].fill = { fgColor: { rgb: 'f8f9fa' } };
              styles[subtotalCell].fill = { fgColor: { rgb: 'f8f9fa' } };
            }
          }

          // Style summary rows if included
          if (exportData.includeSummary) {
            const summaryRow1 = startRow + itemCount - 3; // "Jumlah" row
            const summaryRow2 = startRow + itemCount - 2; // Counts row
            
            // Style "Jumlah" cell
            const jumlahCell = XLSX.utils.encode_cell({ r: summaryRow1, c: 1 });
            styles[jumlahCell] = { 
              font: { bold: true, size: 11, color: { rgb: '2c3e50' } },
              border: { 
                top: { style: 'thin', color: { rgb: 'dee2e6' } },
                bottom: { style: 'double', color: { rgb: '95a5a6' } }
              },
              alignment: { horizontal: 'left' }
            };
            
            // Style total quantity
            const totalQtyCell = XLSX.utils.encode_cell({ r: summaryRow1, c: 2 });
            styles[totalQtyCell] = { 
              font: { bold: true, size: 11, color: { rgb: '2c3e50' } },
              numFmt: numberFormat,
              border: { 
                top: { style: 'thin', color: { rgb: 'dee2e6' } },
                bottom: { style: 'double', color: { rgb: '95a5a6' } }
              },
              alignment: { horizontal: 'right' }
            };
            
            // Style grand total
            const totalSubtotalCell = XLSX.utils.encode_cell({ r: summaryRow1, c: 4 });
            styles[totalSubtotalCell] = { 
              font: { bold: true, size: 11, color: { rgb: '2c3e50' } },
              numFmt: currencyFormat,
              border: { 
                top: { style: 'thin', color: { rgb: 'dee2e6' } },
                bottom: { style: 'double', color: { rgb: '95a5a6' } },
                left: { style: 'thin', color: { rgb: 'dee2e6' } },
                right: { style: 'thin', color: { rgb: 'dee2e6' } }
              },
              alignment: { horizontal: 'right' }
            };
            
            // Style transaction counts
            const countCell = XLSX.utils.encode_cell({ r: summaryRow2, c: 1 });
            styles[countCell] = { 
              font: { italic: true, size: 10, color: { rgb: '7f8c8d' } },
              alignment: { horizontal: 'left' }
            };
          }
        });

        // Create worksheet and apply styles
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        
        // Apply merges
        if (merges.length > 0) {
          worksheet['!merges'] = merges;
        }
        
        // Apply styles
        Object.entries(styles).forEach(([cellRef, style]) => {
          if (!worksheet[cellRef]) worksheet[cellRef] = {};
          if (!worksheet[cellRef].s) worksheet[cellRef].s = {};
          worksheet[cellRef].s = { ...worksheet[cellRef].s, ...style };
        });

        // Set column widths
        worksheet['!cols'] = [
          { wch: 2 },   // Empty column (spacer)
          { wch: 50 },  // Product name
          { wch: 12 },  // Qty
          { wch: 15 },  // Harga
          { wch: 15 }   // Subtotal
        ];

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Laporan Penjualan");
        
        // Generate filename
        // const startDate = exportData.startDate ? 
        //   new Date(exportData.startDate).toISOString().split('T')[0] : 
        //   new Date().toISOString().split('T')[0];
        // const endDate = exportData.endDate ? 
        //   new Date(exportData.endDate).toISOString().split('T')[0] : 
        //   new Date().toISOString().split('T')[0];
        
        const filename = `Laporan_Penjualan_${exportData.dateRange}.xlsx`;
        
        // Save the file
        XLSX.writeFile(workbook, filename);

        // Show success message
        this.$toast.add({
          severity: 'success',
          summary: 'Ekspor Berhasil',
          detail: 'Laporan berhasil diekspor',
          life: 3000
        });

      } catch (error) {
        console.error('Export error:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Ekspor Gagal',
          detail: 'Terjadi kesalahan saat mengekspor laporan',
          life: 3000
        });
      }
    }
  },
};
</script>
